document.querySelectorAll('.ModalSelectCity').forEach((modal) => {
    const select = modal.querySelector('.modal__search .SearchableInput');
    const btn = document.querySelector('.yes-modalyourcity');
    if(select) {
        select.addEventListener('select', (e) => {
            const item = e.detail;
            citySet(item && item.innerText, item && item.dataset.value)
            closeModal('.ModalSelectCity');
            goToSearch();
        });
    }
    if(btn) {
        btn.addEventListener('click', (e) => {
            closeModal(btn.closest('.modal'));
            goToSearch();
        });
    }

    modal.addEventListener('select', (e) => {
        const elSelect = e.detail;
        citySet(elSelect && elSelect.innerText, elSelect && elSelect.dataset.value)
        goToSearch();
    });

    modal.querySelectorAll('.ModalSelectCity__step>*[data-value]').forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            citySet(item && item.innerText, item && item.dataset.value)
            goToSearch();
        });
    })
})
